<template>
    <div class="HouseGrades">
        <div class="row">
            <h3>
                <font-awesome-icon :icon="['fa', 'arrow-left']" @click="ChangeStartDate(-7)" class="pointer" /> <font-awesome-icon :icon="['fa', 'sync-alt']" @click="GetAllGrades()" class="olive-green-text pointer" />  <font-awesome-icon :icon="['fa', 'arrow-right']" @click="ChangeStartDate(7)" class="pointer" />
            </h3>
        </div>
        <div class="row" style="overflow-x:auto;">
            <table style="width:100%; margin-top: 15px;" class="table-striped table-hover">
                <thead>
                    <tr class="center-cells">
                        <th style="border-style:none;"></th>
                        <th v-for="gradeDate in GetDateList" colspan="2">
                            {{ gradeDate.date }}
                        </th>
                    </tr>
                    <tr class="center-cells">
                        <th style="border-style:none;"></th>
                        <th v-for="gradeDate in GetDateList" colspan="2">
                            {{ gradeDate.day }}
                        </th>
                    </tr>
                    <tr class="center-cells">
                        <th style="border-style:none;"></th>
                        <th>
                            AM
                        </th>
                        <th>
                            PM
                        </th>
                        <th>
                            AM
                        </th>
                        <th>
                            PM
                        </th>
                        <th>
                            AM
                        </th>
                        <th>
                            PM
                        </th>
                        <th>
                            AM
                        </th>
                        <th>
                            PM
                        </th>
                        <th>
                            AM
                        </th>
                        <th>
                            PM
                        </th>
                        <th>
                            AM
                        </th>
                        <th>
                            PM
                        </th>
                        <th>
                            AM
                        </th>
                        <th>
                            PM
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="client in ResidenceData.ClientSubProgramResidenceMemberships">
                        <td class="bold">{{ client.ClientSubProgramMembership.Client.Person.FirstNameLastInitial }}</td>
                        <td class="pointer center-text" v-for="clientCurrentGrades in ReturnClientCurrentGrades(client.ClientSubProgramMembershipID)" @click="OpenGradeEditor(clientCurrentGrades, client.ClientSubProgramMembership.Client.Person.FirstNameLastInitial)">
                            <span v-if="clientCurrentGrades.ClientNotPresent">
                                NP
                            </span>
                            <span v-else-if="clientCurrentGrades.Id">
                                {{ clientCurrentGrades.Employee.Person.Initials }}
                            </span>
                            <span else>

                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        

        <!--ADD AND EDIT AND DETAIL MODAL-->
        <b-modal ref="grade-modal" size="lg" :title="ModalTitle" hide-footer>
            <b-container>
                <b-form @submit="AddEditGrade">
                    <!--GRADES SECTION-->
                    <div class="row top-margin-sm record-section-row">
                        <div class="col-sm-4 bold">
                            <font-awesome-icon :icon="['fa', 'bed']" /> Wakeup/Bedtime:
                        </div>
                        <div class="col-sm-1 center-text bold">
                            {{ GradeEditorValues.GradeWakeBed }}
                        </div>
                        <div class="col-sm-7">
                            <vue-slider v-model="GradeEditorValues.GradeWakeBed" v-bind="SliderOptions" />
                        </div>
                        <div class="col-sm-12 top-margin-sm bottom-margin-sm">
                            <input type="text" class="form-control" v-model="GradeEditorValues.NotesWakeBed" placeholder="Notes" />
                        </div>
                    </div>
                    <div class="row top-margin-sm record-section-row">
                        <div class="col-sm-4 bold">
                            <font-awesome-icon :icon="['fa', 'shower']" /> Hygiene:
                            <b-form-checkbox size="lg" v-model="GradeEditorValues.DidShower" value="true" unchecked-value="false">Showered</b-form-checkbox>
                        </div>
                        <div class="col-sm-1 center-text bold">
                            {{ GradeEditorValues.GradeHygiene }}
                        </div>
                        <div class="col-sm-7">
                            <vue-slider v-model="GradeEditorValues.GradeHygiene" v-bind="SliderOptions" />
                        </div>
                        <div class="col-sm-12 top-margin-sm bottom-margin-sm">
                            <input type="text" class="form-control" v-model="GradeEditorValues.NotesHygiene" placeholder="Notes" />
                        </div>
                    </div>
                    <div class="row top-margin-sm record-section-row">
                        <div class="col-sm-4 bold">
                            <font-awesome-icon :icon="['fa', 'futbol']" /> Personal Space:
                        </div>
                        <div class="col-sm-1 center-text bold">
                            {{ GradeEditorValues.GradePersonalSpace }}
                        </div>
                        <div class="col-sm-7">
                            <vue-slider v-model="GradeEditorValues.GradePersonalSpace" v-bind="SliderOptions" />
                        </div>
                        <div class="col-sm-12 top-margin-sm bottom-margin-sm">
                            <input type="text" class="form-control" v-model="GradeEditorValues.NotesPersonalSpace" placeholder="Notes" />
                        </div>
                    </div>
                    <div class="row top-margin-sm record-section-row">
                        <div class="col-sm-4 bold">
                            <font-awesome-icon :icon="['fa', 'book']" /> House Rules:
                        </div>
                        <div class="col-sm-1 center-text bold">
                            {{ GradeEditorValues.GradeHouseRules }}
                        </div>
                        <div class="col-sm-7">
                            <vue-slider v-model="GradeEditorValues.GradeHouseRules" v-bind="SliderOptions" />
                        </div>
                        <div class="col-sm-12 top-margin-sm bottom-margin-sm">
                            <input type="text" class="form-control" v-model="GradeEditorValues.NotesHouseRules" placeholder="Notes" />
                        </div>
                    </div>
                    <div class="row top-margin-sm record-section-row">
                        <div class="col-sm-4 bold">
                            <font-awesome-icon :icon="['fa', 'briefcase']" /> ILS:
                        </div>
                        <div class="col-sm-1 center-text bold">
                            {{ GradeEditorValues.GradeILS }}
                        </div>
                        <div class="col-sm-7">
                            <vue-slider v-model="GradeEditorValues.GradeILS" v-bind="SliderOptions" />
                        </div>
                        <div class="col-sm-12 top-margin-sm bottom-margin-sm">
                            <input type="text" class="form-control" v-model="GradeEditorValues.NotesILS" placeholder="Notes" />
                        </div>
                    </div>
                    <div class="row top-margin-sm record-section-row">
                        <div class="col-sm-4 bold">
                            <font-awesome-icon :icon="['fa', 'graduation-cap']" /> School:
                        </div>
                        <div class="col-sm-1 center-text bold">
                            {{ GradeEditorValues.GradeSchool }}
                        </div>
                        <div class="col-sm-7">
                            <vue-slider v-model="GradeEditorValues.GradeSchool" v-bind="SliderOptions" />
                        </div>
                        <div class="col-sm-12 top-margin-sm bottom-margin-sm">
                            <input type="text" class="form-control" v-model="GradeEditorValues.NotesSchool" placeholder="Notes" />
                        </div>
                    </div>
                    <div class="row top-margin-sm record-section-row">
                        <div class="col-sm-4 bold">
                            <font-awesome-icon :icon="['fa', 'child']" /> Peer Relations:
                        </div>
                        <div class="col-sm-1 center-text bold">
                            {{ GradeEditorValues.GradePeerRelations }}
                        </div>
                        <div class="col-sm-7">
                            <vue-slider v-model="GradeEditorValues.GradePeerRelations" v-bind="SliderOptions" />
                        </div>
                        <div class="col-sm-12 top-margin-sm bottom-margin-sm">
                            <input type="text" class="form-control" v-model="GradeEditorValues.NotesPeerRelations" placeholder="Notes" />
                        </div>
                    </div>
                    <div class="row top-margin-sm record-section-row">
                        <div class="col-sm-4 bold">
                            <font-awesome-icon :icon="['fa', 'user']" /> Adult Relations:
                        </div>
                        <div class="col-sm-1 center-text bold">
                            {{ GradeEditorValues.GradeAdultRelations }}
                        </div>
                        <div class="col-sm-7">
                            <vue-slider v-model="GradeEditorValues.GradeAdultRelations" v-bind="SliderOptions" />
                        </div>
                        <div class="col-sm-12 top-margin-sm bottom-margin-sm">
                            <input type="text" class="form-control" v-model="GradeEditorValues.NotesAdultRelations" placeholder="Notes" />
                        </div>
                    </div>
                    <div class="row top-margin-sm record-section-row">
                        <div class="col-sm-4 bold">
                            <font-awesome-icon :icon="['fa', 'stethoscope']" /> Treatment:
                        </div>
                        <div class="col-sm-1 center-text bold">
                            {{ GradeEditorValues.GradeTreatment }}
                        </div>
                        <div class="col-sm-7">
                            <vue-slider v-model="GradeEditorValues.GradeTreatment" v-bind="SliderOptions" />
                        </div>
                        <div class="col-sm-12 top-margin-sm bottom-margin-sm">
                            <input type="text" class="form-control" v-model="GradeEditorValues.NotesTreatment" placeholder="Notes" />
                        </div>
                    </div>
                    <div class="row top-margin-sm record-section-row">
                        <div class="col-sm-4 bold">
                            <font-awesome-icon :icon="['fa', 'star']" /> Target Behavior:
                        </div>
                        <div class="col-sm-1 center-text bold">
                            {{ GradeEditorValues.GradeTargetBehavior }}
                        </div>
                        <div class="col-sm-7">
                            <vue-slider v-model="GradeEditorValues.GradeTargetBehavior" v-bind="SliderOptions" />
                        </div>
                        <div class="col-sm-12" style="margin-top:10px;">
                            <p v-for="targetBehavior in TargetBehaviors">--{{ targetBehavior.BehaviorDescription }}</p>
                        </div>
                        <div class="col-sm-12 top-margin-sm bottom-margin-sm">
                            <input type="text" class="form-control" v-model="GradeEditorValues.NotesTargetBehavior" placeholder="Notes" />
                        </div>
                    </div>
                    <div class="row top-margin-sm record-section-row">
                        <div class="col-md-12 top-margin-sm bottom-margin-sm">
                            <h4>BIRs:</h4>
                        </div>
                        <div class="col-md-4 top-margin-sm bottom-margin-sm">
                            <div class="form-group">
                                <label class="bold">Behavior:</label>
                                <textarea class="form-control" v-model="GradeEditorValues.BIRBehavior" rows="5"></textarea>
                            </div>
                        </div>
                        <div class="col-md-4 top-margin-sm bottom-margin-sm">
                            <div class="form-group">
                                <label class="bold">Intervention:</label>
                                <textarea class="form-control" v-model="GradeEditorValues.BIRIntervention" rows="5"></textarea>
                            </div>
                        </div>
                        <div class="col-md-4 top-margin-sm bottom-margin-sm">
                            <div class="form-group">
                                <label class="bold">Response:</label>
                                <textarea class="form-control" v-model="GradeEditorValues.BIRResponse" rows="5"></textarea>
                            </div>
                        </div>
                    </div>
                    <b-row>
                        <div class="col-xs-12">
                            <b-form-checkbox size="lg" v-model="GradeEditorValues.ClientNotPresent" value="true" unchecked-value="false"> Client Not Present</b-form-checkbox>
                        </div>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelGrades()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                            <b-button size="md" variant="danger" @click="DeleteGrade(GradeEditorValues.Id)" type="button" v-if="GradeEditorValues.Id">
                                DELETE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
    library.add(faArrowLeft);
    import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
    library.add(faArrowRight);
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faBed } from '@fortawesome/free-solid-svg-icons';
    library.add(faBed);
    import { faShower } from '@fortawesome/free-solid-svg-icons';
    library.add(faShower);
    import { faFutbol } from '@fortawesome/free-solid-svg-icons';
    library.add(faFutbol);
    import { faBook } from '@fortawesome/free-solid-svg-icons';
    library.add(faBook);
    import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
    library.add(faBriefcase);
    import { faGraduationCap } from '@fortawesome/free-solid-svg-icons';
    library.add(faGraduationCap);
    import { faChild } from '@fortawesome/free-solid-svg-icons';
    library.add(faChild);
    import { faUser } from '@fortawesome/free-solid-svg-icons';
    library.add(faUser);
    import { faStethoscope } from '@fortawesome/free-solid-svg-icons';
    library.add(faStethoscope);
    import { faStar } from '@fortawesome/free-solid-svg-icons';
    library.add(faStar);
    import { faTimes } from '@fortawesome/free-solid-svg-icons';
    library.add(faTimes);
    import { faCheck } from '@fortawesome/free-solid-svg-icons';
    library.add(faCheck);
    //import components
    import VueSlider from 'vue-slider-component';
    import 'vue-slider-component/theme/antd.css';

    import { EventBus } from '../../../../services/event-bus.js';

    export default {
        props: [
            "ResidenceData"
        ],
        data: function () {
            return {
                StartDate: "",
                ModalTitle: "",
                HouseWeeklyGrades: [],
                GradeEditorValues: {},
                TargetBehaviors: [],
                GradeSchema: {
                    //Info
                    Id: "",
                    EmployeeID: "",
                    Employee: {},
                    GradeDate: "",
                    AMPM: "",
                    DidShower: false,
                    //Grades
                    GradeWakeBed: 0,
                    GradeHygiene: 0,
                    GradePersonalSpace: 0,
                    GradeHouseRules: 0,
                    GradeILS: 0,
                    GradeSchool: 0,
                    GradePeerRelations: 0,
                    GradeAdultRelations: 0,
                    GradeTreatment: 0,
                    GradeTargetBehavior: 0,
                    //Notes
                    NotesWakeBed: "",
                    NotesHygiene: "",
                    NotesPersonalSpace: "",
                    NotesHouseRules: "",
                    NotesILS: "",
                    NotesSchool: "",
                    NotesPeerRelations: "",
                    NotesAdultRelations: "",
                    NotesTreatment: "",
                    NotesTargetBehavior: "",
                    //BIRs
                    BIRBehavior: "",
                    BIRIntervention: "",
                    BIRResponse: "",
                    ClientNotPresent: false
                },
                SliderOptions: {
                    dotSize: 30,
                    width: 'auto',
                    height: 4,
                    contained: false,
                    direction: 'ltr',
                    data: null,
                    min: 0,
                    max: 4,
                    interval: 1,
                    disabled: false,
                    clickable: true,
                    duration: 0.5,
                    adsorb: false,
                    lazy: false,
                    tooltip: 'active',
                    tooltipPlacement: 'top',
                    tooltipFormatter: void 0,
                    useKeyboard: true,
                    keydownHook: null,
                    dragOnClick: false,
                    enableCross: true,
                    fixed: false,
                    minRange: void 0,
                    maxRange: void 0,
                    order: true,
                    marks: true,
                    dotOptions: void 0,
                    process: true,
                    dotStyle: void 0,
                    railStyle: void 0,
                    processStyle: void 0,
                    tooltipStyle: void 0,
                    stepStyle: void 0,
                    stepActiveStyle: void 0,
                    labelStyle: void 0,
                    labelActiveStyle: void 0,
                }
            };
        },
        methods: {
            ChangeStartDate(magnitude) {
                this.StartDate = moment(this.StartDate, 'YYYY-MM-DD').add(magnitude, 'days').format("YYYY-MM-DD");
                this.GetAllGrades();
            },
            DeleteGrade(gradeID) {
                this.$MasterAPI.ExecuteRequest("POST", "Residential/Clients/ClientGrades/DeleteGrades", { Id: gradeID }, this.DeleteGradeSuccess, () => { }, true);
            },
            DeleteGradeSuccess(response) {
                this.GetAllGrades();
                this.$refs["grade-modal"].hide();
            },
            OpenGradeEditor(gradeObject, clientName) {
                this.TargetBehaviors = [];
                this.GetTargetBehaviors(gradeObject.ClientSubProgramMembershipID, gradeObject.GradeDate);
                this.ModalTitle = clientName + ": " + gradeObject.GradeDate + " (" + gradeObject.AMPM + ")";
                this.GradeEditorValues = JSON.parse(JSON.stringify(gradeObject));
                this.$refs["grade-modal"].show();
            },
            GetTargetBehaviors(cpmID, targetDate) {
                this.$MasterAPI.ExecuteRequest("GET", "Residential/Clients/TargetBehaviors/GetClientTargetBehaviorsActiveOnSpecificDate", { ClientSubProgramMembershipID: cpmID, TargetDate: targetDate }, this.GetTargetBehaviorsSuccess, () => { }, false);
            },
            GetTargetBehaviorsSuccess(response) {
                this.TargetBehaviors = response.data.data;
            },
            AddEditGrade(e) {
                e.preventDefault();
                if (!this.GradeEditorValues.Id) {
                    this.GradeEditorValues.Id = "00000000-0000-0000-0000-000000000000"
                    this.GradeEditorValues.EmployeeID = "00000000-0000-0000-0000-000000000000"
                }
                this.$MasterAPI.ExecuteRequest("POST", "Residential/Clients/ClientGrades/AddOrUpdateGrades", this.GradeEditorValues, this.AddEditGradeSuccess, () => { }, true);
            },
            AddEditGradeSuccess(response) {
                this.GetAllGrades();
                this.$refs["grade-modal"].hide();
            },
            CancelGrades() {
                this.$refs["grade-modal"].hide();
            },
            ReturnClientCurrentGrades(cpmID) {
                let vm = this;
                let output = [];
                let clientFiltered = vm.HouseWeeklyGrades.filter(g => g.ClientSubProgramMembershipID == cpmID);
                vm.GetDateList.forEach(function (dateItem) {
                    //GENERATE AM
                    let foundAM = false;
                    clientFiltered.forEach(function (gradeItem) {
                        if (gradeItem.GradeDate == dateItem.compdate && gradeItem.AMPM == "AM") {
                            output.push(gradeItem);
                            foundAM = true;
                            //break;
                        }
                    });
                    if (foundAM == false) {
                        let newGrade = JSON.parse(JSON.stringify(vm.GradeSchema));
                        newGrade.GradeDate = dateItem.compdate;
                        newGrade.ClientSubProgramMembershipID = cpmID;
                        newGrade.AMPM = "AM";
                        newGrade.ClientNotPresent = false;
                        output.push(
                            newGrade
                        )
                    }
                    //GENERATE PM
                    let foundPM = false;
                    clientFiltered.forEach(function (gradeItem) {
                        if (gradeItem.GradeDate == dateItem.compdate && gradeItem.AMPM == "PM") {
                            output.push(gradeItem);
                            foundPM = true;
                            //break;
                        }
                    });
                    if (foundPM == false) {
                        let newGrade = JSON.parse(JSON.stringify(vm.GradeSchema));
                        newGrade.GradeDate = dateItem.compdate;
                        newGrade.ClientSubProgramMembershipID = cpmID;
                        newGrade.AMPM = "PM";
                        newGrade.ClientNotPresent = false;
                        output.push(
                            newGrade
                        )
                    }
                });

                return output;
            },
            GetAllGrades() {
                this.$MasterAPI.ExecuteRequest("GET", "Residential/Clients/ClientGrades/GetClientsGradeStatusForResidence", { StartDate: this.StartDate, ResidenceID: this.ResidenceData.Id }, this.GetAllGradesSuccess, () => { }, false);
            },
            GetAllGradesSuccess(response) {
                  response.data.data.forEach(function(item) {
                      item.GradeDate = item.GradeDate.substring(0, 10);
                  });
                  this.HouseWeeklyGrades = response.data.data;
            },
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
        },
        components: {
            VueSlider
        },
        mounted() {
            //set current target date to the most previous Wednesday
            let dayOfWeek = parseInt(moment().format("e"));
            let dayOfWeekWedZero = dayOfWeek - 3;
            if (dayOfWeekWedZero < 0) {
                dayOfWeekWedZero = 7 + dayOfWeekWedZero;
            }
            this.StartDate = moment().add(dayOfWeekWedZero * -1, "days").format("YYYY-MM-DD");
            //Get House Grades
            this.GetAllGrades();
        },
        computed: {
            GetDateList: function () {
                let startDate = this.StartDate;
                let dateOutput = []
                let weeks = ["Wed", "Thu", "Fri", "Sat", "Sun", "Mon", "Tue"];
                if (startDate) {
                    for (var i = 0; i < 7; i++) {
                        let nextDate = moment(startDate, 'YYYY-MM-DD').add(i, 'days').format('MM/DD/YY');
                        let compDate = moment(startDate, 'YYYY-MM-DD').add(i, 'days').format('YYYY-MM-DD');
                        dateOutput.push({
                            day: weeks[i],
                            date: nextDate,
                            compdate: compDate
                        });
                    }
                    return dateOutput;
                } else {
                    return []
                }
            },
        }    
    }
</script>

<style scoped>
    .top-margin-md {
        margin-top: 20px;
    }
    .top-margin-sm {
        margin-top: 12px;
    }
    .bottom-margin-sm {
        margin-bottom: 12px;
    }

    .center-cells td, .center-cells th {
        text-align: center;
    }

    table td, table th {
        border-style: solid;
    }
</style>